import React, { Component } from "react";
import keeperImg from "../../images/4-removebg-preview-removebg-preview.png";

class Form extends Component {
  state = {
    rows: [
      {
        imageURL: "",
        name: "",
        size: "",
        number: "",
        sleeves: "",
        socksColor: "#000000",
      },
    ],
    showPopup: false,

    // Fan Version
    addFanVersion: false,
    fanVersion: {
      size: "",
      sleeves: "",
    },
  };

  handleChange = (index, field, value) => {
    const rows = [...this.state.rows];
    rows[index][field] = value;
    this.setState({ rows });
  };

  handleFanChange = (field, value) => {
    this.setState({
      fanVersion: {
        ...this.state.fanVersion,
        [field]: value,
      },
    });
  };

  addRow = () => {
    const firstColor =
      this.state.rows.length > 0
        ? this.state.rows[0].socksColor
        : "#000000";

    this.setState((prev) => ({
      rows: [
        ...prev.rows,
        {
          imageURL: "",
          name: "",
          size: "",
          number: "",
          sleeves: "",
          socksColor: firstColor,
        },
      ],
    }));
  };

  deleteRow = (index) => {
    const rows = [...this.state.rows];
    rows.splice(index, 1);
    this.setState({ rows });
  };

  openPopup = () => this.setState({ showPopup: true });
  closePopup = () => this.setState({ showPopup: false });

  render() {
    const { addFanVersion, fanVersion, showPopup } = this.state;

    return (
      <>
        <style>{`
          .nice-input {
            width:100%;
            padding:11px 12px;
            border-radius:12px;
            border:1px solid #d8dee8;
            background:rgba(255,255,255,0.65);
            font-size:14px;
          }

          .soft-table th {
            background:#1d3557;
            color:white;
            padding:14px;
            font-size:14px;
            font-weight:700;
          }

          .soft-table td {
            padding:14px;
            border-bottom:1px solid #e9ecf2;
            background:white;
          }

          .neon-green-btn {
            background: linear-gradient(135deg, #32ff72, #46ff60);
            color: #0b1a23;
            padding: 12px 32px;
            border-radius: 40px;
            border: none;
            cursor: pointer;
            font-weight: 700;
            box-shadow: 0px 4px 18px rgba(60,255,90,0.35);
          }

          .delete-btn {
            background:#e63946;
            color:white;
            border:none;
            padding:8px 15px;
            border-radius:10px;
            cursor:pointer;
          }

          @keyframes fadeIn {
            from { opacity:0; }
            to { opacity:1; }
          }

          @keyframes popupScale {
            from { transform:scale(.7); opacity:0; }
            to { transform:scale(1); opacity:1; }
          }
        `}</style>

        <div style={{ padding: "45px 0" }}>
          <div
            style={{
              padding: "25px 35px",
              maxWidth: "1000px",
              margin: "auto",
              background: "rgba(255,255,255,0.08)",
              backdropFilter: "blur(14px)",
              borderRadius: "20px",
              border: "1px solid rgba(255,255,255,0.22)",
              boxShadow: "0 0 30px rgba(0,0,0,0.20)",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #1d3557, #2c4e7a)",
                padding: "20px",
                borderRadius: "14px",
                marginBottom: "25px",
                textAlign: "center",
                color: "white",
                fontWeight: "700",
                fontSize: "24px",
              }}
            >
              Connect Kit Form
            </div>

            {/* MAIN TABLE */}
            <table className="soft-table" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Size</th>
                  <th>Number</th>
                  <th>Sleeves</th>
                  <th>Socks Color</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {this.state.rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {row.imageURL ? (
                        <img
                          src={row.imageURL}
                          alt=""
                          style={{
                            width: "90px",
                            height: "90px",
                            objectFit: "cover",
                            borderRadius: "12px",
                          }}
                        />
                      ) : (
                        <span style={{ color: "#9ca3af" }}>No Image</span>
                      )}
                    </td>

                    <td>
                      <input
                        className="nice-input"
                        placeholder="Name"
                        value={row.name}
                        onChange={(e) =>
                          this.handleChange(index, "name", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <select
                        className="nice-input"
                        value={row.size}
                        onChange={(e) =>
                          this.handleChange(index, "size", e.target.value)
                        }
                      >
                        <option value="">Choose</option>
                        <option>S</option>
                        <option>M</option>
                        <option>L</option>
                        <option>XL</option>
                        <option>2XL</option>
                      </select>
                    </td>

                    <td>
                      <input
                        type="number"
                        className="nice-input"
                        placeholder="Number"
                        value={row.number}
                        onChange={(e) =>
                          this.handleChange(index, "number", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <select
                        className="nice-input"
                        value={row.sleeves}
                        onChange={(e) =>
                          this.handleChange(index, "sleeves", e.target.value)
                        }
                      >
                        <option value="">Choose</option>
                        <option value="half">Half Sleeves</option>
                        <option value="full">Full Sleeves</option>
                      </select>
                    </td>

                    <td>
                      <input
                        type="color"
                        value={row.socksColor}
                        onChange={(e) =>
                          this.handleChange(index, "socksColor", e.target.value)
                        }
                        style={{
                          width: "42px",
                          height: "42px",
                          borderRadius: "10px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </td>

                    <td>
                      <button
                        type="button"
                        className="delete-btn"
                        onClick={() => this.deleteRow(index)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* ADD ROW */}
            <div style={{ textAlign: "right", marginTop: "18px" }}>
              <button
                type="button"
                onClick={this.addRow}
                className="neon-green-btn"
              >
                + Add Row
              </button>
            </div>

            {/* FAN VERSION CHECKBOX */}
            <div
              style={{
                marginTop: "18px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: "#fff",
                fontWeight: "600",
              }}
            >
              <input
                type="checkbox"
                checked={addFanVersion}
                onChange={(e) =>
                  this.setState({ addFanVersion: e.target.checked })
                }
              />
              Add Fan Version
            </div>

            {/* FAN VERSION FORM */}
            {addFanVersion && (
              <div
                style={{
                  marginTop: "16px",
                  padding: "18px",
                  background: "rgba(255,255,255,0.15)",
                  borderRadius: "14px",
                }}
              >
                <h4 style={{ color: "#fff", marginBottom: "12px" }}>
                  Fan Version Details
                </h4>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "14px",
                  }}
                >
                  <select
                    className="nice-input"
                    value={fanVersion.size}
                    onChange={(e) =>
                      this.handleFanChange("size", e.target.value)
                    }
                  >
                    <option value="">Select Size</option>
                    <option>S</option>
                    <option>M</option>
                    <option>L</option>
                    <option>XL</option>
                    <option>2XL</option>
                  </select>

                  <select
                    className="nice-input"
                    value={fanVersion.sleeves}
                    onChange={(e) =>
                      this.handleFanChange("sleeves", e.target.value)
                    }
                  >
                    <option value="">Select Sleeves</option>
                    <option value="half">Half Sleeves</option>
                    <option value="full">Full Sleeves</option>
                  </select>
                </div>
              </div>
            )}

            {/* ADD TO CART */}
            <div style={{ textAlign: "center", marginTop: "35px" }}>
              <button
                type="button"
                onClick={this.openPopup}
                className="neon-green-btn"
              >
                🛒 Add to Cart
              </button>
            </div>
          </div>

          {/* POPUP */}
          {showPopup && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.75)",
                backdropFilter: "blur(10px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 999,
                animation: "fadeIn .35s ease",
              }}
            >
              <div
                style={{
                  width: "480px",
                  background: "#08121c",
                  borderRadius: "22px",
                  padding: "28px",
                  textAlign: "center",
                  border: "1px solid rgba(0,255,120,0.35)",
                  boxShadow: "0 0 35px rgba(0,255,150,0.35)",
                  animation: "popupScale .4s ease",
                }}
              >
                <img
                  src={keeperImg}
                  alt=""
                  style={{
                    width: "100%",
                    borderRadius: "14px",
                    marginBottom: "18px",
                  }}
                />

                <h2 style={{ color: "#00ffbf", marginBottom: "14px" }}>
                  Build Your Ultimate GK Kit
                </h2>

                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <button
                    onClick={() => (window.location.href = "/goalkeeper")}
                    className="neon-green-btn"
                  >
                    Customize Goalkeeper Kit
                  </button>

                  <button
                    onClick={() => (window.location.href = "/cart")}
                    className="neon-green-btn"
                  >
                    Go to Cart
                  </button>

                  <button
                    onClick={this.closePopup}
                    className="neon-green-btn"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default Form;
